module.exports = __webpack_public_path__ + "static/img/3.c8400e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/3.png
// module id = OTdz
// module chunks = 0